






























import { RETRY_SEND_MSG } from '@/const/eventBus';
import { defineComponent, ref, watch } from '@vue/composition-api';
export default defineComponent({
  props: {
    value: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { root, emit }: any) {
    const msg = ref('');

    const onClickClose = () => {
      emit('click-close');
    };

    const onClickConfirm = () => {
      emit('click-confirm', msg.value);
    };

    root.$emitter.on(RETRY_SEND_MSG, () => {
      emit('update:value', '');
    });

    watch(
      () => props.showDialog,
      (newValue) => {
        if (newValue) {
          msg.value = props.value;
        }
      },
      { immediate: true },
    );
    return {
      msg,
      onClickClose,
      onClickConfirm,
    };
  },
});
